import React from 'react';
import AdminPanel from './Component/AdminPanel/AdminPanel';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import MainPage from './Component/AdminPanel/MainPage';
import SearchDoctors from './Component/Doctors/SearchDoctors';
import Login from './Component/AdminPanel/Login';
import SignUp from './Component/AdminPanel/SignUp';
import DoctorProfile from './Component/Doctors/DoctorProfile';
import Booking from './Component/Profile/Booking';
import MyProfile from './Component/Profile/MyProfile';
import Dashboard from './Component/Profile/Dashboard';
import Appointment from './Component/Profile/Appointment';
import Favourites from './Component/Profile/Favourites';
import Dependent from './Component/Profile/Dependent';
import MedicalRecords from './Component/Profile/MedicalRecords';
import Accounts from './Component/Profile/Accounts';
import Invoices from './Component/Profile/Invoices';
import Chat from './Component/Profile/Chat';
import MedicalDetails from './Component/Profile/MedicalDetails';
import ProfileSettings from './Component/Profile/ProfileSettings';
import CompanyProfile from './Component/Hospital/CompanyProfile';
import ProtectedRoute from './Component/AdminPanel/ProtectedRoute';
import LabReport from './Component/Report/LabReport';
import { Navigate } from 'react-router-dom';
import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
import { AuthProvider } from './Component/context/AuthContext';
import PatientSettings from './Component/Profile/PatientSettings';
import Forget from './Component/AdminPanel/Forget';
function App() {
  // const [isLoggedIn, setIsLoggedIn] = useState(() => {
  //   return !!localStorage.getItem("email");
  // });

  // useEffect(() => {
  //   const handleStorage = () => {
  //     setIsLoggedIn(!!localStorage.getItem("email"));
  //   };

  //   window.addEventListener("storage", handleStorage);
  //   return () => window.removeEventListener("storage", handleStorage);
  // }, []);
 // Empty dependency array ensures this runs only once after the first render
 const queryClient = new QueryClient();
   return (
    <QueryClientProvider client={queryClient}>
      <AuthProvider>
        <Router>
          <Routes>
           
            {/* ================= ADMIN PANEL LAYOUT ================= */}
            <Route path="/" element={<AdminPanel />}>

             {/* PUBLIC ROUTES */}
  <Route index element={<MainPage />} />
  <Route path="main-page" element={<MainPage />} />
  <Route path="login" element={<Login />} />
  <Route path="sign-up" element={<SignUp />} />
  <Route path="search-doctors" element={<SearchDoctors />} />
  <Route path="lab-report" element={<LabReport />} />
  <Route path="forget" element={<Forget />} />
  
  <Route path="company-profile" element={<CompanyProfile />} />
  <Route path="doctor-profile" element={<DoctorProfile />} />

  {/* PROTECTED ROUTES - CLEAN WRAPPER */}
  <Route element={<ProtectedRoute />}>

    <Route path="booking" element={<Booking />} />
    <Route path="patient-chat" element={<Chat />} />
    {/* PATIENT PROFILE LAYOUT - NO path="/" ! */}
    <Route element={<MyProfile />}>   {/* ← pathless layout route */}
      <Route path="patient-dashboard" element={<Dashboard />} />
      <Route path="patient-appointments" element={<Appointment />} />
      <Route path="patient-favourites" element={<Favourites />} />
      <Route path="patient-dependent" element={<Dependent />} />
      <Route path="patient-medical-records" element={<MedicalRecords />} />
      <Route path="patient-accounts" element={<Accounts />} />
      <Route path="patient-invoices" element={<Invoices />} />
      <Route path="patient-medical-details" element={<MedicalDetails />} />
      <Route path="patient-settings" element={<ProfileSettings />} />
      <Route path="patient-profile" element={<PatientSettings />} />
    </Route>
  </Route>           
   </Route>

            {/* fallback */}
            <Route path="*" element={<Navigate to="/main-page" replace />} />

          </Routes>
        </Router>
      </AuthProvider>
    </QueryClientProvider>
  );
}

export default App;
